module.exports = __webpack_public_path__ + "media/sns/Facebook_Logo_Secondary-14150615.png";